import styled from 'styled-components';
import { motion } from 'framer-motion';

export const MissionControlContainer = styled.div`
  padding: 2rem;
  height: 100%;
  background: #ffffff;
  color: #333333;
  position: relative;
  overflow-x: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  color: #333333;
  font-family: 'Orbitron', sans-serif;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--primary);
  
  svg{
    width:25px;
    color: var(--primary);
  }
`;

export const StatusBadge = styled.div`
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  font-size: 0.8rem;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 1rem;
  border: 1px solid rgba(16, 185, 129, 0.3);
  
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
    box-shadow: 0 0 10px rgba(16, 185, 129, 0.7);
  }
`;

export const ActionBar = styled.div`
  display: flex;
  gap: 1rem;
`;

export const ActionButton = styled(motion.button)`
  padding: 0.6rem 1.2rem;
  background: rgba(0, 102, 255, 0.1);
  border: 1px solid rgba(0, 102, 255, 0.3);
  border-radius: 8px;
  color: #333333;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 102, 255, 0.2);
    border-color: rgba(0, 102, 255, 0.5);
    box-shadow: 0 0 15px rgba(0, 102, 255, 0.3);
  }
`;

export const TimeFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 1rem;
  background: rgba(240, 240, 240, 0.7);
  border: 1px solid rgba(0, 102, 255, 0.2);
  border-radius: 8px;
  padding: 0.3rem;
`;

export const TimeOption = styled.button`
  padding: 0.3rem 0.8rem;
  border-radius: 6px;
  font-size: 0.8rem;
  border: none;
  background: ${props => props.active ? 'rgba(0, 102, 255, 0.2)' : 'transparent'};
  color: ${props => props.active ? '#333333' : 'rgba(0, 0, 0, 0.6)'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.active ? 'rgba(0, 102, 255, 0.2)' : 'rgba(0, 102, 255, 0.1)'};
    color: #333333;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto auto auto;
  gap: 1.5rem;
  height: calc(100% - 5rem);
`;

export const KPICard = styled(motion.div)`
background: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  display: flex;
  min-width:0px;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  position: relative;
  justify-content: space-between;
  

`;

export const KPITitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  svg {
    width: 18px;
    height: 18px;
    color: rgba(0, 102, 255, 0.8);
  }
`;

export const KPIValue = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  color: #333333;
  margin: 1rem 0;
  font-family: 'Orbitron', sans-serif;
  
  span {
    font-size: 1rem;
    color: ${props => props.trend === 'up' 
      ? props.positive ? '#10b981' : '#ef4444'
      : props.trend === 'down' 
        ? props.positive ? '#ef4444' : '#10b981'
        : 'rgba(0, 0, 0, 0.5)'};
    margin-left: 0.5rem;
  }
`;

export const KPIChart = styled.div`
  height: 60px;
  margin-top: auto;
  position: relative;
  
  canvas {
    width: 100%;
    height: 100%;
  }
`;

export const KPIFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
`;

export const ClaimsLeakageCard = styled(KPICard)`
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  
`;

export const TATCard = styled(KPICard)`
  grid-column: 2 / 3;
  grid-row: 1 / 2;
`;

export const STPCard = styled(KPICard)`
  grid-column: 3 / 4;
  grid-row: 1 / 2;
`;

export const FraudDetectionCard = styled(KPICard)`
  grid-column: 4 / 5;
  grid-row: 1 / 2;
`;

export const DigitizationOverviewCard = styled(motion.div)`
  grid-column: 1 / 3;
  grid-row: 2 / 4;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  display: flex;
  min-width:0px;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  position: relative;
  
 
`;

export const SectionTitle = styled.h3`
      
  font-size: 1.2rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 0.75rem;
  font-family: 'Orbitron', sans-serif;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  
  span {
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.5);
  }
`;

export const DigitizationMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const MetricItem = styled.div`
  background: rgba(240, 240, 240, 0.5);
  border: 1px solid rgba(0, 102, 255, 0.1);
  border-radius: 8px;
  padding: 1rem;
`;

export const MetricName = styled.div`
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 0.5rem;
`;

export const MetricValue = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: #333333;
  font-family: 'Orbitron', sans-serif;
`;

export const DigitizationChart = styled.div`
  height: 250px;
  margin-top: 1rem;
  position: relative;
  
  canvas {
    width: 100%;
    height: 100%;
  }
`;

export const AgentPerformanceCard = styled(motion.div)`
  grid-column: 3 / 5;
  grid-row: 2 / 3;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  border: 1px solid #e2e8f0;
  position: relative;
`;

export const AgentList = styled.div`
  margin-top: 1rem;
`;

export const AgentItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.8rem;
  border-radius: 8px;
  background: rgba(240, 240, 240, 0.5);
  margin-bottom: 0.8rem;
  border: 1px solid rgba(0, 102, 255, 0.1);
`;

export const AgentIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.1);
  border: 1px solid rgba(0, 102, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  font-size: 1.2rem;
  color: rgba(0, 102, 255, 0.8);
`;

export const AgentInfo = styled.div`
  flex: 1;
`;

export const AgentName = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 0.3rem;
`;

export const AgentMetrics = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
`;

export const AgentMetric = styled.div`
  span {
    color: ${props => props.highlight ? props.color || 'rgba(0, 102, 255, 0.8)' : '#333333'};
    font-weight: ${props => props.highlight ? '600' : '400'};
    margin-left: 0.3rem;
  }
`;

export const AgentPerformance = styled.div`
  width: 100px;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
  margin-left: auto;
  
  &::before {
    content: '';
    display: block;
    height: 100%;
    width: ${props => props.value}%;
    background: ${props => {
      if (props.value >= 80) return '#10b981';
      if (props.value >= 50) return '#f59e0b';
      return '#ef4444';
    }};
    border-radius: 3px;
  }
`;

export const ClaimsProcessingCard = styled(motion.div)`
  grid-column: 3 / 5;
  grid-row: 3 / 4;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  position: relative;
`;

export const ProcessingStages = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
`;

export const StageItem = styled.div`
  flex: 1;
  text-align: center;
  position: relative;
  
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 25px;
    right: 0;
    width: calc(100% - 60px);
    height: 2px;
    background: rgba(0, 102, 255, 0.3);
  }
`;

export const StageIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.1);
  border: 1px solid rgba(0, 102, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 1.5rem;
  color: rgba(0, 102, 255, 0.8);
  position: relative;
  z-index: 1;
  
  ${props => props.active && `
    background: rgba(0, 102, 255, 0.2);
    box-shadow: 0 0 15px rgba(0, 102, 255, 0.5);
  `}
  
  ${props => props.completed && `
    background: rgba(16, 185, 129, 0.2);
    border-color: rgba(16, 185, 129, 0.5);
    color: #10b981;
  `}
`;

export const StageName = styled.div`
  font-size: 0.8rem;
  color: ${props => props.active ? '#333333' : 'rgba(0, 0, 0, 0.6)'};
  font-weight: ${props => props.active ? '600' : '400'};
`;

export const StageMetric = styled.div`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 0.3rem;
`;

export const BackgroundAnimation = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.05;
`;

export const GridOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 102, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 102, 255, 0.05) 1px, transparent 1px);
  background-size: 30px 30px;
  z-index: -1;
`;

export const DataStream = styled.div.attrs(props => ({
  style: {
    height: props.height || '100px',
    top: props.top || '0',
    left: props.left || '0',
    animationDuration: props.duration || '2s'
  },
}))`
  position: absolute;
  width: 2px;
  background: linear-gradient(to bottom, rgba(0, 102, 255, 0), rgba(0, 102, 255, 0.5), rgba(0, 102, 255, 0));
  opacity: 0.3;
  animation: streamAnimation infinite linear;
  
  @keyframes streamAnimation {
    0% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(100vh);
    }
  }
`;

export const GlowEffect = styled.div.attrs(props => ({
  style: {
    top: props.top || '50%',
    left: props.left || '50%'
  },
}))`
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 102, 255, 0.1) 0%, rgba(0, 102, 255, 0) 70%);
  filter: blur(20px);
  z-index: 0;
  transform: translate(-50%, -50%);
`;
